module.exports = __webpack_public_path__ + "static/img/logo-szfn.37d068d.png";